module.exports = __webpack_public_path__ + "img/pic_10.af238cfa.jpg";